<template>
  <el-container class="faceContrast" v-loading="loading">
    <!--  人脸对比-->
    <div class="faceContrast-left">
      <h-upload
        ref="uploadFirstRef"
        :iconStyle="iconStyle"
        :showUpload="true"
      ></h-upload>
    </div>
    <div class="faceContrast-center">
      <div class="echarts" id="echartsliquidFill"></div>
      <!-- <div class="faceContrast-center-select"></div> -->
      <h-button type="primary" @click="startContrast">开始对比</h-button>
    </div>
    <div class="faceContrast-right">
      <h-upload
        ref="uploadSecondRef"
        :iconStyle="iconStyle"
        :showUpload="true"
      ></h-upload>
    </div>
  </el-container>
</template>

<script>
import { defineComponent, reactive, toRefs, ref, onMounted } from "vue";
import * as echarts from "echarts";
import {
  queryinstalled,
  queryFileSimilar,
} from "@/api/smartApplication/smartApplicationApi.js";
import { useRouter } from "vue-router";
import "echarts-liquidfill";
import { url2ToBase } from "@/api/smartApplication/personSearchApi.js";
import { ElMessage } from "element-plus";
export default defineComponent({
  name: "faceContrast",
  components: {},
  props: {},
  setup(props) {
    const state = reactive({
      loading: false,
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      iconStyle: {
        fontSize: "140px",
        lineHeight: "240px",
      },
      form: {
        sf: "", // 算法
      },
      sfData: [], //下拉框数据
      similarity: 0, //相似度
    });
    const refData = toRefs(state);
    // const treeRef = ref(null);
    const uploadFirstRef = ref();
    const uploadSecondRef = ref();
    const router = useRouter();
    let echartsliquidFill;
    onMounted(async () => {
      if (router.currentRoute.value.query.img) {
        const params = {
          paths: [router.currentRoute.value.query.img],
        };
        const res = await url2ToBase(params);
        uploadFirstRef.value.uploadFilesValue(
          "data:image/jpeg;base64," + res.data
        );
      }

      window.addEventListener("resize", () => {
        echartsliquidFill.resize();
      });
    });
    // 点击开始对比按钮
    const startContrast = async () => {
      if (
        (uploadFirstRef.value.fileList[0] == null &&
          uploadFirstRef.value.base64File[0] == null) ||
        uploadSecondRef.value.base64File[0] == null
      ) {
        ElMessage.warning("请添加图片");
      } else {
        state.loading = true;
        let firstImage;
        if (uploadFirstRef.value.fileList == 0) {
          let posFirst = uploadFirstRef.value.base64File[0].lastIndexOf(",");
          firstImage = uploadFirstRef.value.base64File[0].substring(
            posFirst + 1,
            uploadFirstRef.value.base64File[0].length
          );
        } else {
          console.log(uploadFirstRef.value.fileList);
          let posFirst = uploadFirstRef.value.fileList[0].url.lastIndexOf(",");
          firstImage = uploadFirstRef.value.fileList[0].url.substring(
            posFirst + 1,
            uploadFirstRef.value.fileList[0].length
          );
        }

        let posSecond = uploadSecondRef.value.base64File[0].lastIndexOf(",");
        let secondImage = uploadSecondRef.value.base64File[0].substring(
          posSecond + 1,
          uploadSecondRef.value.base64File[0].length
        );
        let params = {
          firstImage: firstImage,
          secondImage: secondImage,
        };
        const res = await queryFileSimilar(params);
        state.loading = false;
        if (res.code == 0) {
          state.similarity = parseInt(res.similarity);
          echartsliquid();
        } else {
          ElMessage.error("对比失败");
        }
      }
    };
    //算法列表查询
    const queryinstalledAsync = async () => {
      const res = await queryinstalled();
      if (res) {
        state.sfData = res.algorithmInstalled;
      }
    };
    queryinstalledAsync();
    const echartsliquid = () => {
      echartsliquidFill = echarts.init(
        document.getElementById("echartsliquidFill")
      );
      console.log(echartsliquidFill);
      const option = {
        series: [
          {
            type: "liquidFill",
            data: [
              {
                value: state.similarity / 100,
                itemStyle: {
                  color: "#42b8f9",
                },
              },
            ],
            radius: "60%",
            amplitude: 5,
            // shape: "container",
            outline: {
              show: false,
            },
            backgroundStyle: {
              borderColor: "#fbfdff",
              color: "#fbfdff",
              // borderWidth: 5,
              // shadowColor: "red",
              // shadowBlur: 20,
            },
            label: {
              position: [
                `50%`,
                `${100 - (state.similarity > 90 ? 90 : state.similarity)}%`,
              ],
              formatter: function () {
                return `${state.similarity}%`;
              },
              fontSize: 20,
              color: "#333",
            },
          },
        ],
      };
      echartsliquidFill.setOption(option, true);
    };
    return {
      ...refData,
      uploadFirstRef,
      uploadSecondRef,
      startContrast,
    };
  },
});
</script>
<style lang="scss" scoped>
.faceContrast {
  @include flex-row-c-c;
  .faceContrast-center {
    margin: 0 16px;
    @include flex-col-c-c;
    .echarts {
      width: 260px;
      height: 260px;
    }
  }
  .faceContrast-center-select {
    margin: 30px 0;
    @include flex-row-c-c;
  }
  /deep/.el-upload--picture-card {
    width: 244px;
    height: 244px;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 244px !important;
    height: 244px !important;
  }
  /deep/.el-upload-list__item-thumbnail {
    width: 244px !important;
    height: 244px !important;
  }
  /deep/.hide > .el-upload--picture-card {
    display: none;
  }
  /deep/.hideOne > .el-upload--picture-card {
    display: none;
  }
}
</style>
